// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qWeo","image":"Header_image__3GYs1","name":"Header_name__cVc5D","info":"Header_info__ZoTUZ","infoRow":"Header_infoRow__1y1GK"};